<template>
     <!-- video area start -->
     <div class="video-area text-center pd-top-115 pd-bottom-120" style="background-image: url('assets/img/widget/data-migration-phases.png');background-size: 76rem;height: 447px;">
     <div class="container">
         <div class="row justify-content-center">
             <div class="col-lg-6 col-md-10">
                 <div class="section-title mb-4 style-white">
                     <!-- <h2 class="title">We Care About Your Life’s Important Things</h2> -->
                 </div>
             </div>
         </div>
     </div>
 </div>
 <!-- video area end -->
</template>
<script>
    export default {
        name: "Video"
    }
</script>